function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1900(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 57.61,
    height: 30.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.402857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 15.41,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.82,
    width: 57.61,
    height: 61.2,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.20125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 61.42,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.02,
    width: 57.61,
    height: 62.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 123.265,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.51,
    width: 57.61,
    height: 63.34,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 186.18,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 217.85,
    width: 57.61,
    height: 72.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.522
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 253.91,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.97,
    width: 57.61,
    height: 73.19,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 326.56500000000005,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.16,
    width: 57.61,
    height: 78.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.401111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 402.32000000000005,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 441.49,
    width: 57.61,
    height: 79.61,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 481.295,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.09,
    width: 57.61,
    height: 89.02,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.601666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 565.6,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 610.12,
    width: 57.61,
    height: 89.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.601666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.805,
    y: 655.06,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 0,
    width: 68.97,
    height: 76.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.62125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.095,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.58,
    y: 0,
    width: 70.1,
    height: 76.15,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.63,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.68,
    y: 0,
    width: 72.53,
    height: 76.15,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.088333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.945,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 0,
    width: 75.44,
    height: 76.15,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.573333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 306.91999999999996,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.65,
    y: 0,
    width: 78.19,
    height: 76.15,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.51875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.745,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.84,
    y: 0,
    width: 90.98,
    height: 76.15,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.691666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.33,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.82,
    y: 0,
    width: 92.12,
    height: 76.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.8800000000001,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.94,
    y: 0,
    width: 94.06,
    height: 76.15,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.97,
    y: 38.075,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 76.15,
    width: 92.81,
    height: 77.98,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.798
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 115.14000000000001,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 154.14,
    width: 92.81,
    height: 82.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.793333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 195.51999999999998,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 236.9,
    width: 92.81,
    height: 87.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.450000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 280.475,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 324.05,
    width: 92.81,
    height: 91.4,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.057142857142859
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 369.75,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 415.44,
    width: 92.81,
    height: 92.33,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.0825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 461.605,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 507.77,
    width: 92.81,
    height: 92.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 554.135,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 600.5,
    width: 92.81,
    height: 99.5,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.258571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.015,
    y: 650.25,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.42,
    y: 76.15,
    width: 98.55,
    height: 98.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.695,
    y: 125.505,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.97,
    y: 76.15,
    width: 102.67,
    height: 98.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.10142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.305,
    y: 125.505,
    fontFamily: "Arial"
  }, "\n        De_Soto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.64,
    y: 76.15,
    width: 107.92,
    height: 98.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.967777777777776
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.59999999999997,
    y: 125.505,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.56,
    y: 76.15,
    width: 118.04,
    height: 98.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.33875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.58,
    y: 125.505,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.59,
    y: 76.15,
    width: 122.41,
    height: 98.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.33875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.7950000000001,
    y: 125.505,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.42,
    y: 174.86,
    width: 128.35,
    height: 95.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.59499999999997,
    y: 222.65,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.42,
    y: 270.44,
    width: 128.35,
    height: 103.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.59499999999997,
    y: 322.165,
    fontFamily: "Arial"
  }, "\n        St._John\u2019s\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.42,
    y: 373.89,
    width: 128.35,
    height: 107.87,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.59499999999997,
    y: 427.825,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.42,
    y: 481.76,
    width: 128.35,
    height: 108.26,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.043333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.59499999999997,
    y: 535.89,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.42,
    y: 590.02,
    width: 128.35,
    height: 109.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.7475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.59499999999997,
    y: 645.01,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.77,
    y: 174.86,
    width: 134.24,
    height: 106.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.89,
    y: 228.175,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.01,
    y: 174.86,
    width: 142.8,
    height: 106.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.40999999999997,
    y: 228.175,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.81,
    y: 174.86,
    width: 144.19,
    height: 106.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.232857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.905,
    y: 228.175,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.77,
    y: 281.49,
    width: 125.17,
    height: 134.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.35499999999996,
    y: 348.71500000000003,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.77,
    y: 415.94,
    width: 125.17,
    height: 136.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.861666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.35499999999996,
    y: 484.15,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.77,
    y: 552.35,
    width: 125.17,
    height: 147.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.861666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.35499999999996,
    y: 626.1750000000001,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.94,
    y: 281.49,
    width: 129.42,
    height: 167.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.488571428571426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.65,
    y: 365.13,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.36,
    y: 281.49,
    width: 166.64,
    height: 167.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.6800000000001,
    y: 365.13,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.94,
    y: 448.77,
    width: 136.82,
    height: 251.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.363999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.35,
    y: 574.385,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.76,
    y: 448.77,
    width: 159.24,
    height: 251.23,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.270000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.38,
    y: 574.385,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1900);
export default __webpack_public_path__ + "static/media/1900.660413fa451e513455dc2ba84a73875f.svg";
export { ForwardRef as ReactComponent };